// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__E8ot3","alertModal":"modal_alertModal__lYW9M"};